<template>
  <div class="row">
    <div class="col-xl-6 col-lg-6 col-md-4 col-sm-4 col-12">
      <div class="input-group">
        <div class="input-group-pprend">
          <v-btn
            :disabled="loading"
            @click="handlePrevMonth"
            class="v-dark noBorderRadius shadow-none"
            style="height: 31px"
            ><i class="fas fa-arrow-left"></i
          ></v-btn>
        </div>
        <input
          :disabled="loading"
          v-if="dayMonthYear == 'day'"
          v-model="month"
          type="date"
          class="form-control form-control-sm"
        />
        <input
          :disabled="loading"
          v-if="dayMonthYear == 'month'"
          v-model="month"
          type="month"
          class="form-control form-control-sm"
          @input="paginate"
        />
        <input
          :disabled="loading"
          v-if="dayMonthYear == 'year'"
          v-model="month"
          type="text"
          class="form-control form-control-sm"
          maxlength="4"
          minlength="4"
          @input="handleInputMonthTypeYear($event.target.value)"
        />
        <div class="input-group-pprend">
          <v-btn
            :disabled="loading"
            @click="handleNextMonth"
            class="v-dark noBorderRadius shadow-none"
            style="height: 31px"
          >
            <i class="fas fa-arrow-right"></i>
          </v-btn>
        </div>
      </div>
    </div>
    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-8 col-12">
      <v-btn
        :disabled="loading"
        class="submenu-finacial"
        style="height: 31px"
        @click="handleDayMonthYear('day')"
        :class="[dayMonthYear == 'day' && 'v-dark']"
        >Dia</v-btn
      >
      <v-btn
        :disabled="loading"
        class="submenu-finacial"
        style="height: 31px"
        @click="handleDayMonthYear('month')"
        :class="[dayMonthYear == 'month' && 'v-dark']"
        >Mês</v-btn
      >
      <v-btn
        :disabled="loading"
        class="submenu-finacial"
        style="height: 31px"
        @click="handleDayMonthYear('year')"
        :class="[dayMonthYear == 'year' && 'v-dark']"
        >Ano</v-btn
      >
      <v-btn
        v-if="dayMonthYear == 'day'"
        :disabled="loading"
        class="submenu-finacial v-dark"
        style="height: 31px"
        @click="paginate"
        ><i class="fas fa-filter mr-1"></i> FILTRAR</v-btn
      >
    </div>
  </div>
</template>

<script>
import { isNumeric } from "../../lib/format";

import moment from "moment";

export default {
  name: "Filter",

  data() {
    return {
      month: moment().format("YYYY-MM"),
      month_tmp: moment().format("YYYY-MM"),
      dayMonthYear: "month",
    };
  },

  props: {
    loading: { type: Boolean, default: false },
  },

  methods: {
    moment,

    handlePrevMonth() {
      let { dayMonthYear } = this;

      if (dayMonthYear == "day") {
        this.month = moment(this.month)
          .subtract(1, "days")
          .format("YYYY-MM-DD");
      } else if (dayMonthYear == "month") {
        this.month = moment(this.month).subtract(1, "month").format("YYYY-MM");
      } else {
        this.month = moment(this.month).subtract(1, "year").format("YYYY");
      }
      this.paginate();
    },

    handleNextMonth() {
      let { dayMonthYear } = this;

      if (dayMonthYear == "day") {
        this.month = moment(this.month).add(1, "days").format("YYYY-MM-DD");
      } else if (dayMonthYear == "month") {
        this.month = moment(this.month).add(1, "month").format("YYYY-MM");
      } else {
        this.month = moment(this.month).add(1, "year").format("YYYY");
      }

      this.paginate();
    },

    handleDayMonthYear(dayMonthYear) {
      if (dayMonthYear == this.dayMonthYear) {
        return;
      }

      let { month, month_tmp } = this;

      this.month = moment().format("YYYY-MM-DD");

      if (dayMonthYear == "month") {
        this.month = moment(month_tmp).format("YYYY-MM");
        this.month_tmp = moment(month_tmp).format("YYYY-MM");
      }

      if (dayMonthYear == "year") {
        this.month = moment(month).format("YYYY");
        this.month_tmp = moment(month_tmp).format("YYYY-MM-DD");
      }

      this.dayMonthYear = dayMonthYear;
      this.paginate();
    },

    handleInputMonthTypeYear(year) {
      if (String(year).length == 4) {
        if (isNumeric(year)) {
          this.paginate();
        }
      }
    },

    paginate() {
      let { month, dayMonthYear } = this;

      this.$emit("paginate", { month, dayMonthYear });
    },
  },
};
</script>
